module.exports = __webpack_public_path__ + "img/stock1.1deeb1cc.png";